/* global I18n */
import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'

const i18nOptions = {
  scope: 'turbosquid.products.product_alerts.draft_warning',
}

const bundlesI18nOptions = {
  scope: 'turbosquid.products.bundles',
}

const BundlesPublishModal = ({ show, hideModal, bundleDescription, orderedPreviews, searchPreview, bundlePriceValidation, bundleTitle }) => (
  <Modal show={show} className="bundles-discard-modal-container" onHide={hideModal}>
    <Modal.Dialog>
      <Modal.Header closeButton style={{ display: 'flex' }}>
        <Modal.Title><b>{I18n.t('publish_requirements_title', bundlesI18nOptions)}</b></Modal.Title>
      </Modal.Header>
      <div>
        <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: '32px' }}>
          <p style={{ paddingLeft: '32px', paddingRight: '20px' }}>
            {I18n.t('publish_requirements_description', bundlesI18nOptions)}
          </p>
          <ul>
            { orderedPreviews.length < 5 && (
              <li>{I18n.t('image_requirement', bundlesI18nOptions)}</li>
            )}
            {!bundleTitle && (
              <li>{I18n.t('title_requirement', bundlesI18nOptions)}</li>
            )}
            { bundlePriceValidation && (
              <li>{I18n.t('price_requirement', bundlesI18nOptions)}</li>
            )}
            { bundleDescription.length < 8 && (
              <li>{I18n.t('description_requirement', bundlesI18nOptions)}</li>
            )}
            {!searchPreview && (
              <li>{I18n.t('search_image_requirement', bundlesI18nOptions)}</li>
            )}
          </ul>
        </div>
      </div>
      <Modal.Footer>
        <div style={{ display: 'flex', justifyContent: 'end' }}>
          <button
            className="bundles-modal-button"
            type="submit"
            onClick={hideModal}>
            {' '}
            {I18n.t('ok', i18nOptions)}
          </button>
        </div>
      </Modal.Footer>
    </Modal.Dialog>
  </Modal>
)

BundlesPublishModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
  show: PropTypes.func.isRequired,
}

export default BundlesPublishModal
